<template>
  <div class="seller-page-container">
    <spinner />
    <toaster />
    <div :class="['seller-custom-header-wrapper',{ compact }]">
      <header class="seller-custom-header frame">
        <div class="header-logo">
          <logo color="#ED1C24" size="40px" />
        </div>
        <div class="header-title">
          <h1>{{ seller.nome ? seller.nome : 'Pedidos' }}</h1>
        </div>
        <div class="header-action">
          <a href="#" class="btn-logout" @click.prevent="logOut()" title="Sair">
            <fa :icon="['far', 'right-from-bracket']" class="icon"></fa>
          </a>
        </div>
      </header>
    </div>
    <div class="pageAlert">
      <p>As entregas de pedidos são atualizadas por ordem de chegada, o tempo de processamento pode variar conforme o volume.</p>
    </div>
    <div class="frame">
      <div class="page-inner" v-if="!loading">
        <div class="search-filter">
          <form @keyup.enter="runFilter" @submit.prevent="">
            <div class="row no-padd">
              <div class="col-md-7 form-group">
                <label>Nome</label>
                <input-control v-model="filter.nome" placeholder="Aluno ou Responsável" autocomplete="on"/>
              </div>
              <div class="col-md-5 form-group">
                <label>Unidade</label>
                <select-control v-model="filter.unidade" :options="unidades" placeholder="Selecione" />
              </div>
              <div class="col-md-4 form-group">
                <label>Data Pedido</label>
                <input-control v-model="filter.dataPedido" placeholder="Data" type="date" />
              </div>
              <div class="col-md-4 form-group">
                <label>Data Recebimento</label>
                <input-control v-model="filter.dataEntrega" placeholder="Data" type="date" />
              </div>
              <div class="col-md-4 form-group">
                <label>Data Prevista Recebimento</label>
                <input-control v-model="filter.dataPrevisaEntrega" placeholder="Data" type="date" />
              </div>
              <div class="col-md-6 form-group checks">
                <label class="check-control">
                  <input type="checkbox" class="check" v-model="filter.recebido" />
                  <span class="">Apenas Entregues</span>
                </label>
              </div>
            </div>
            <div class="col-md-12 form-actions form-group">
              <a href="#" class="btn btn-primary" @click.prevent="runFilter()">
                Filtrar
              </a>
              <a href="#" class="btn btn-secondary" @click.prevent="clear()">
                Limpar
              </a>
            </div>
          </form>
        </div>
        <section :class="['collapseList', { lock: processing }]">
          <div class="collapseFilter" v-if="filtered">
            <div>
              <div class="iconWrap">
                <fa :icon="['fas', 'filter-list']"></fa>
              </div>
              <div class="searchWrap">
                <input-control v-model="searchQuery" @keyup="searchList" placeholder="Buscar..." cssClass="" :readonly="processing"></input-control>
              </div>
              <div class="searchWrap">
                <select-control v-model="orderBy" :options="orders" @input="sortList" placeholder="Ordenar por..." cssClass="" :disable="processing"></select-control>
              </div>
              <div class="searchWrap">
                <select-control v-model="filterType" :options="filterTypes" @input="filterList" placeholder="Filtrar por..." cssClass="" :disable="processing"></select-control>
              </div>
            </div>
            <div class="multitask-actions">
              <transition name="slideup-small">
                <label class="check-control">
                  <span class="">Todos</span>
                  <input type="checkbox" class="check" value="todos" name="todos" v-model="todos" @change="selectAll"/>
                  <span class="amountTag" v-if="selected.length > 0">
                    {{ selected.length }} Selecionados
                  </span>
                </label>
              </transition>
            </div>
          </div>
          <ul v-if="pedidos.length > 0">
            <li v-for="(pedido, i) in pedidos" :key="pedido.idpedidomaterial" @click="!preventParentClick ? toggleCollapse(true, i, pedido) : null" :class="{ active: pedido.collapse }">
              <card :boxed="true" overflow="visible">
                <div>
                  <header>
                    <div>
                      <span :class="{active: pedido.collapse}" @mouseenter="preventParentClick = true" @mouseleave="preventParentClick = false" @click="toggleCollapse(false, i, pedido)"></span>
                    </div>
                    <span class="">
                      {{ pedido.codigo }}
                    </span>
                    <span class="large-cell">
                      {{ pedido.nome }}
                    </span>
                    <span class="fixed-cell">
                      {{ formatMoney(pedido.valorPedido) }}
                    </span>
                    <span class="small-cell">
                      {{ pedido.sigla ? pedido.sigla : '-' }}
                    </span>
                    <span class="fixed-cell">
                      {{ pedido.nomeTurma }}
                    </span>
                    <span class="fixed-cell" >
                      <span tooltip="Data do Pedido">
                        <fa :icon="['fas', 'cart-circle-check']" class="icon"></fa>
                        {{ pedido.datapedido }}
                      </span>
                    </span>
                    <span class="fixed-cell">
                      <span tooltip="Previsão de Recebimento">
                        <fa :icon="['fas', 'calendar-star']" class="icon"></fa>
                        {{ pedido.entregaprevista }}
                      </span>
                    </span>
                    <span class="fixed-cell">
                      <span tooltip="Data do Recebimento" :class="['marker', pedido.entregaAtrasada && 'warning']">
                        <fa :icon="['fas', 'truck-ramp-box']" class="icon"></fa>
                        {{ pedido.entregaconfirmada === 1 ? pedido.dataentrega : 'Não recebido' }}
                      </span>
                    </span>
                    <!-- <span class="fixed-cell">
                      <span tooltip="Data da Entrega" :class="['marker', pedido.saidaconfirmada === 1 || pedido.datasaida != null ? 'success' : 'warning']">
                        <fa :icon="['fas', 'person-carry-box']" class="icon"></fa>
                        {{ pedido.saidaconfirmada === 1 ? formatDate(pedido.datasaida) : 'Não entregue' }}
                      </span>
                    </span> -->
                    <div class="alerts">
                      <p tooltip="NFe">
                        {{ pedido.numnota ?? '' }}
                      </p>
                      <a :href="pedido.danfe" target="_blank" :class="[pedido.danfe ? 'active' : 'lock']">
                        <fa :icon="['fas', 'file-invoice-dollar']" :class="['icon']" title="Nota Fiscal"/>
                      </a>
                      <a :href="pedido.etiqueta" target="_blank" :class="pedido.etiqueta ? 'active' : 'lock'">
                        <fa :icon="['fas', 'tag']" :class="['icon']" title="Etiqueta"/>
                      </a>
                    </div>
                    <div class="checkWrap" @mouseenter="preventParentClick = true" @mouseleave="preventParentClick = false" >
                      <input type="checkbox" class="check invert" v-model="selected" :value="pedido.idpedidomaterial" @change="trackFilterType()"/>
                    </div>
                    <transition name="slideRightToLeft">
                      <div class="listStamp" v-if="pedido.nomeLote && !pedido.collapse">
                        <fa :icon="['fas','calendar-range']" class="icon"></fa>
                        <b><p>{{ pedido.nomeLote }}</p></b>
                      </div>
                    </transition>
                  </header>
                  <transition name="slidedown-small">
                    <div class="checkoutDetails" v-if="pedido.collapse">
                      <input-spinner class="detailsSpinner" v-if="pedido.loadingDetails" />
                      <template v-else>
                        <div class="checkoutDetailsLists">
                          <div>
                            <header>
                              <h5>Itens Pedido</h5>
                              <!-- <div>
                                <a href="#" class="btn btn-primary" @click.prevent="enviarNota(pedido)" v-if="!pedido.danfe && allowEmitirNota">
                                  Adicionar Nota Fiscal &nbsp;
                                  <fa :icon="['fas', 'file-invoice']"/>
                                </a>
                                <a href="#" class="btn btn-primary" @click.prevent="gerarNota(pedido)" v-if="!pedido.danfe && allowEmitirNota">
                                  Gerar Nota Fiscal &nbsp;
                                  <fa :icon="['fas', 'receipt']"/>
                                </a>
                                <a href="#" @click.prevent="confirmCancelPedido(pedido)" class="btn btn-secondary">
                                  Cancelar Pedido &nbsp;
                                  <fa :icon="['fas','trash-can']"></fa>
                                </a>
                              </div> -->
                            </header>
                            <div v-if="pedido.nomeLote" class="cardsub">
                              <fa :icon="['fas','calendar-range']" class="icon"></fa>
                              <h6 class="color-text">{{ pedido.nomeLote }}</h6>
                            </div>
                            <table>
                              <thead>
                                <tr>
                                  <th>Entregue</th>
                                  <th>Item</th>
                                  <th>Grade</th>
                                  <th>Valor Unitário</th>
                                  <th>Quantidade</th>
                                  <th>Valor Total</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="item in pedido.items" :key="item">
                                  <td>
                                    <div class="deliver">
                                      <fa :icon="['fas', 'clipboard-check']" :class="['icon', { active: item.dataEntrega }]" />
                                      <span v-if="item.dataEntrega">{{ formatDate(item.dataEntrega) }}</span>
                                      <span v-else>Não entregue</span>
                                    </div>
                                  </td>
                                  <td>{{ item.tipomaterial }}</td>
                                  <td>{{ item.descricaoGrade }}</td>
                                  <td>{{ formatMoney(item.valoritem) }}</td>
                                  <td>{{ item.quantidade }}x</td>
                                  <td>{{ formatMoney(item.somaValorItens) }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </template>
                    </div>
                  </transition>
                </div>
              </card>
            </li>
          </ul>
          <transition name="">
            <div class="emptyMessage" v-if="pedidos.length == 0 && filtered">
              <span>
                <fa :icon="['fal','face-meh']" class="icon"/>
                <p>Não encontramos nada..</p>
              </span>
            </div>
          </transition>
        </section>
        <confirm 
          :backdrop="false"
          class="confirm"
          ref="confirm"
        ></confirm>
      </div>
      <modal ref="nfModal" wrapped>
        <div class="modalWrap nfModal">
          <etiquetas />
        </div>
      </modal>
    </div>
    <footer v-if="allowSave || allowPrintList">
      <template v-if="allowPrintList">
        <div>
          <!-- <label class="check-control">
            <input type="checkbox" class="check" v-model="groupListItems">
            <span>Agrupar Pessoas</span>
          </label> -->
          <a href="#" @click.prevent="imprimirLista()" class="btn btn-primary" >Imprimir Lista</a>
          <a href="#" @click.prevent="imprimirEtiquetas()" class="btn btn-primary" >Imprimir Etiquetas</a>
        </div>
      </template>
      <transition name="slideup-small">
        <a href="#" @click.prevent="receber()" class="btn btn-primary" v-if="filterType == 'naorecebido'">Entregar Pedidos</a>
      </transition>
    </footer>
  </div>
</template>

<script>
import MarketplaceService from '@/services/marketplace.service.js'
import UserService from '@/services/user.service.js'
// import AcademicoService from '@/services/academico.service'
import { formatDate, formatMoney, createSelectOptions } from '@/services/utils.service.js'
import InputSpinner from '@/components/utilities/InputSpinner.vue'
import Logo from '@/components/template/logo.vue'
import Etiquetas from '@/components/marketplace/seller/Etiquetas.vue'
import Modal from '@/components/utilities/Modal.vue'
import moment from 'moment'

export default {
  components: {
    InputSpinner,
    Logo,
    Etiquetas,
    Modal
  },
  watch: {
    selected ( value ) {
      this.allowSave = value.length > 0
      this.allowPrintList = value.length > 0
      console.log("allowSave:", this.allowSave)
    }
  },
  data () {
    return {
      seller: {},
      loading: false,
      depositos: [],
      fornecedores: [],
      unidades: [],
      filter: {
        nome: null,
        unidade: null,
        fornecedor: null,
        fornecedores: null,
        dataPedido: null,
        dataEntrega: null,
        dataPrevisaEntrega: null,
        recebido: null,
      },
      wait: {
        fornecedores: false,
        unidades: false,
      },
      nf: {
        loading: false,
        target: null, 
        form: {
          numero: null,
          serie: null,
          chave: null,
          dataEmissao: null,
          valorTotal: null,
          danfeUrl: null,
          status: null,
          xmlUrl: null,
          etiqueta: null
        },
        options: {
          status: [
            { label: 'Aprovado', value: 'Aprovado' },
            { label: 'Reprovado', value: 'Reprovado' }
          ],
      },
        valid: {
          numero: true,
          serie: true,
          chave: true,
          dataEmissao: true,
          valorTotal: true,
          status: null,
          xmlUrl: null,
          danfeUrl: null,
        }
      },
      pedidos: [],
      backup: [],
      preventParentClick: false,
      processing: false,
      searchQuery: null,
      orderBy: 'default',
      orders: [
        {
          label: 'Ordenação Padrão',
          value: 'default'
        },
        { 
          label: 'ID Pedido A→B',
          value: 'idpedidomaterial-asc'
        },
        { 
          label: 'ID B→A',
          value: 'idpedidomaterial-desc'
        },
        { 
          label: 'Código Pedido A→B',
          value: 'codigo-asc'
        },
        { 
          label: 'Código Pedido B→A',
          value: 'codigo-desc'
        },
        { 
          label: 'Responsável A→B',
          value: 'nome-asc'
        },
        { 
          label: 'Responsável B→A',
          value: 'nome-desc'
        },
        { 
          label: 'Data A→B',
          value: 'datapedido-asc'
        },
        { 
          label: 'Data B→A',
          value: 'datapedido_unix-desc'
        },
        { 
          label: 'Previsão Entrega A→B',
          value: 'entregaprevista_unix-asc'
        },
        { 
          label: 'Previsão Entrega B→A',
          value: 'entregaprevista_unix-desc'
        },
        { 
          label: 'NFe A→B',
          value: 'numnota-asc'
        },
        { 
          label: 'NFe B→A',
          value: 'numnota-desc'
        }
      ],
      filterTypes: [
        {
          label: 'Ver Todos',
          value: 'all'
        },
        {
          label: 'Não Entregue (Para entregar na unidade, utilize essa opção)',
          value: 'naorecebido'
        }
      ],
      selected: [],
      filterType: "all",
      allowSave: false,
      todos: false,
      filtered: false,
      allowPrintList: false,
      printList: [],
      loadingPeriodos: false,
      loadingSeries: false,
      loadingTurmas: false,
      groupListItems: false,
      allowEmitirNota: false,
      compact: false,
      currentUser: localStorage.getItem('profile') ? JSON.parse(atob(localStorage.getItem('profile'))) : null
    }
  },
  mounted () {

    this.seller = this.currentUser.fornecedor
    console.log("seller:", this.seller)
    this.getFornecedores()
    this.getUnidades()
    this.compactHeader()
    this.allowEmitirNota = this.seller && this.seller.emitirNota === 1
  },
  methods: {
    tooltip() {
      const items = document.querySelectorAll('[tooltip]')
      let tooltip

      const appendTooltip = (e) => {
        const target = e.currentTarget

        tooltip = document.createElement('div')
        tooltip.textContent = target.getAttribute('tooltip')
        tooltip.classList.add('tipper')

        const bounding = target.getBoundingClientRect()

        tooltip.style.position = 'fixed'
        tooltip.style.top = `${bounding.top}px`
        tooltip.style.left = `${bounding.left}px`

        document.body.appendChild(tooltip)
      }

      const removeTooltip = () => {
        if (tooltip) {
          tooltip.remove()
          tooltip = null
        }
      }

      items.forEach((k) => {
        k.addEventListener('mouseenter', appendTooltip)
        k.addEventListener('mouseleave', removeTooltip)
      })
    },
    getDepositos () {
      MarketplaceService.getDepositos().then(
        response => {
          // console.log("response:", response.data)
          this.depositos = createSelectOptions(response.data, 'iddepositomaterial' ,'descricao')
          this.wait.depositos = true
          this.stopSpinner()

        },
        error => {
          console.error(error)
        }
      )
    },
    getFornecedores () {
      this.fornecedores = createSelectOptions([this.seller], 'idFornecedor' ,'nome')
      console.log("this.fornecedores:", this.seller.idFornecedor)
      this.filter.fornecedores = this.seller.idFornecedor
    },
    getUnidades () {
      UserService.getMinhasUnidades().then(
        response => {
          console.log("getMinhasUnidades:", response.data)
          this.unidades = createSelectOptions(response.data, 'idUnidade' ,'descricao')
          this.wait.unidades = true
          this.stopSpinner()
        },
        error => {
          console.error(error)
        }
      )
      // this.unidades = createSelectOptions(this.seller.unidades, 'idUnidade' ,'descricao')
    },
    runFilter () {     
      const empty = Object.values(this.filter).every(e => !e)
      
      if ( empty ) {
        window.toaster.emit('open', {style: "warning", message: "Preencha ao menos um campo, para filtrar.", floater: true})
      } else {
        this.filtered = false;
        // this.loading = true
        this.selected = []
        this.filterType = 'all'

        window.spinner.emit("open")

        console.log("this.filter:", this.filter)
        MarketplaceService.filterPedidosSeller(this.filter, this.seller.idFornecedor).then(
          response => {
            if (response.data.length > 0 ) {
              console.log("pedidos:", response.data)

              response.data.map ( k => {
                k.collapse = false
                k.loadingDetails = false
                k.data = {}
                k.datapedido_unix = moment(k.datapedido, 'DD/MM/YYYY').unix()
                k.entregaprevista_unix = moment(k.entregaprevista, 'DD/MM/YYYY').unix()
                k.dataentrega_unix = k.dataentrega ? moment(k.dataentrega, 'DD/MM/YYYY').unix() : '...'
                
                const descricao = k.descricao.split(" - ")
                const codPedido = descricao[0]
                const nomeAluno = descricao[1]

                k.codigo = codPedido
                k.aluno = nomeAluno

                const previsao = moment(k.entregaprevista, 'DD/MM/YYYY')
                const today = moment()
                const diff = today.diff(previsao, 'days')

                k.entregaAtrasada = diff > 0 && k.entregaconfirmada !== 1
                
                this.filtered = true
              })

              this.pedidos = response.data

              this.cloneData()
              
              console.log("this.pedidos:", this.pedidos)
              // window.pagescroll.emit('goto', 500)
              
              setTimeout(() => {
                this.tooltip()
                this.orderBy = 'default'
                this.filterType = 'all'
              },500)
            } else {
              this.pedidos = []          
              window.toaster.emit('open', {style: "warning", message: "Ops. Não econtramos pedidos com os dados inseridos.", floater: true})
            }
            
            window.spinner.emit("close")
            // this.loading = false

          },
          error => {
            console.error(error)
            window.spinner.emit("close")
            // this.loading = false
          }
        )
      
      }
      
    },
    toggleCollapse ( collapse, index, item, checkout, force ) {
      const target = this.pedidos[index]

      if ( !target.collapse && collapse || force ) {
        this.reload = {
          collapse: collapse,
          index: index,
          item: item,
          checkout: checkout
        }
        console.log("item:", item)
        // console.log("target:", target)
        // console.log("checkout:", checkout)
        target.collapse = collapse
        target.loadingDetails = true
        
        const calendario = item.idcalendarioentrega ? item.idcalendarioentrega : 0
        console.log('calendario:', calendario)

        MarketplaceService.getItemsPedidos(item.idpedidomaterial, item.idAluno, item.idFornecedor, calendario).then(
          response => {
            target.loadingDetails = false
            target.items = response.data
            // target.data.transacoes = response.data.transacoes

            console.log("getItemsPedidos:", response)
          },
          error => {
            console.error('error:', error.response)
            target.loadingDetails = false
          }
        )
      } else {
        target.collapse = collapse
      }
    },
    clear () {
      this.filter = {
        nome: null,
        unidade: null,
        periodoLetivo: null,
        serie: null,
        turma: null,
        depositos: null,
        fornecedor: null,
        dataPedido: null,
        dataEntrega: null,
        dataPrevisaEntrega: null,
        recebido: null,
        faturado: null
      }
      this.periodosLetivos = []
      this.series = []
      this.turmas = []
    },
    stopSpinner () {
      const done = !Object.values(this.wait).includes(false)

      if ( done ) {
        window.spinner.emit("close")
        this.loading = false
      }
    },
    cloneData () {
      const pedidos = []

      this.pedidos.map( k => {
        pedidos.push(k)
      })

      this.backup = pedidos
    },
    searchList () {
      const query = this.searchQuery?.toLowerCase()
      
      if ( query && query.length > 3 ) {
        // console.log("query:", query)
        // const filtered = asArray.filter(([key, value]) => typeof value === 'string')
        const filtered = this.pedidos.filter( k => {
          const descricao = k.descricao ? k.descricao.toLowerCase() : ''
          const previsao = k.entregaprevista
          const lote = k.nomeLote ? k.nomeLote.toLowerCase() : ''
          const nome = k.nome ? k.nome.toLowerCase() : ''

          return descricao.includes(query) || previsao.includes(query) || lote.includes(query) || nome.includes(query)
        })

        this.pedidos = filtered
        console.log("filtered:", filtered)
        // const justStrings = Object.fromEntries(filtered)

      } else {
        console.log("this.backup", this.backup)
        this.pedidos = this.backup
      }
    },
    sortList () {
      this.processing = true
      this.cloneData()

      if ( this.orderBy === 'default' ) {
        this.pedidos = this.backup
      } else {
        const by = this.orderBy.split("-")[0]
        const order = this.orderBy.split("-")[1]

        var sorted = order == 'asc' ? this.pedidos.sort((a,b) => (a[by] > b[by]) ? 1 : ((b[by] > a[by]) ? -1 : 0)) : this.pedidos.sort((a,b) => (a[by] > b[by]) ? -1 : ((b[by] > a[by]) ? 1 : 0))
        // console.log('sorted:', sorted)

        this.pedidos = sorted

        setTimeout(() => {
          this.processing = false
        },500)
      }
    },
    filterList () {
      // console.log(e.target.checked)
      // console.log(e.target.value)
      console.log('filterType:', this.filterType)

      var filtered
      this.pedidos = this.backup
      this.selected = []
      this.todos = false
      
      if ( this.filterType === 'recebido' ) {
        filtered = this.pedidos.filter( k => {
          return k.entregaconfirmada == 1 && ( k.saidaconfirmada == 0 || !k.saidaconfirmada )
        })
      }
      if ( this.filterType === 'naorecebido' ) {
        filtered = this.pedidos.filter( k => {
          return ( k.entregaconfirmada == 0 || !k.entregaconfirmada )
        })
      }
      // if ( this.filterType === 'retirada' ) {
      //   filtered = this.pedidos.filter( k => {
      //     return k.entregaconfirmada == 1 && !k.saidaconfirmada
      //   })
      // }
      if ( this.filterType === 'entregue' ) {
        filtered = this.pedidos.filter( k => {
          return k.saidaconfirmada == 1
        })
      }
      if ( this.filterType === 'naoentregue' ) {
        filtered = this.pedidos.filter( k => {
          return k.saidaconfirmada == 0 || !k.saidaconfirmada
        })
      }
      if ( this.filterType === 'adimplente' ) {
        filtered = this.pedidos.filter( k => {
          return k.debitos_mensalidades == 0 && ( k.bloqueiaPedido == 0 || !k.bloqueiaPedido )
        })
      }
      if ( this.filterType === 'inadimplente' ) {
        filtered = this.pedidos.filter( k => {
          return k.bloqueiaPedido == 1
        })
      }
      if ( this.filterType === 'naoentregueadimplente' ) {
        filtered = this.pedidos.filter( k => {
          // console.log("k:", k)
          return ( k.saidaconfirmada == 0 || !k.saidaconfirmada ) && ( !k.bloqueiaPedido || k.bloqueiaPedido == 0 )
        })
      }
      if ( this.filterType === 'naoentregueinadimplente' ) {
        filtered = this.pedidos.filter( k => {
          // console.log("k:", k)
          return ( k.saidaconfirmada == 0 || !k.saidaconfirmada ) && k.bloqueiaPedido == 1
        })
      }
      if ( this.filterType == 'all' ) {
        filtered = this.backup
      }
      // filtered = filtered.length == 0 ? this.backup : filtered

      // console.log('filtered:', filtered)
      this.pedidos = filtered
    },
    receber () {
      // console.log("this.selected", this.selected)
        
      MarketplaceService.disponivelUnidadeSeller(this.selected).then(
        response => {
          console.log("disponivelUnidade:", response.data)
          this.runFilter()
        },
        error => {
          console.error("response.error:", error)
        }
      )
    },
    formatDate ( value ) {
      return formatDate(value)
    },
    formatMoney ( value ) {
      return formatMoney(value)
    },
    selectAll ( e ) {
      if ( e.target.checked ) {
        var selected = []

        this.pedidos.map( k => {
          selected.push(k.idpedidomaterial)
        })

        this.selected = selected
      } else {
        this.selected = []
      }
    },
    trackFilterType () {
      // 
    },
    imprimirLista () {
      // console.log("this.pedidos:", this.pedidos)
      // console.log("this.selected:", this.selected)
      this.printList = this.pedidos.filter( k => {
        return this.selected.includes(k.idpedidomaterial)
      })
      
      localStorage.setItem('PrintList', JSON.stringify(this.printList))
      
      // console.log("data:", data)
      // this.$router.push({name:'Lista Entrega'})
      const compact = this.groupListItems
      console.log("compact:", compact)

      window.open('/marketplace/lista-entrega?seller=true&compact=' + compact,'_blank')
    },
    imprimirEtiquetas () {
      // console.log("this.pedidos:", this.pedidos)
      // console.log("this.selected:", this.selected)
      this.printList = this.pedidos.filter( k => {
        return this.selected.includes(k.idpedidomaterial)
      })
      
      localStorage.setItem('PrintList', JSON.stringify(this.printList))
      
      // console.log("data:", data)
      // this.$router.push({name:'Lista Entrega'})
      const compact = this.groupListItems
      console.log("compact:", compact)

      window.open('/marketplace/imprimir-etiquetas-pedidos?compact=' + compact,'_blank')
    },
    gerarNota ( pedido ) {
      console.log("gerarNota:", pedido)
      const idAluno = pedido.idAluno
      const idcheckoutMarketplace = pedido.idCheckoutMarketplace

      window.spinner.emit("open")
      MarketplaceService.gerarPedido(idAluno, idcheckoutMarketplace, 1).then(
        response => {
          console.log("response:", response)
          if ( response.status == 200 ) {
            window.toaster.emit('open', {style: "success", message: "Tudo certo! Solicitação enviada com sucesso. O Processo pode demorar alguns minutos.", floater: true})
          }

          window.spinner.emit("close")
        },
        () => {
          window.toaster.emit('open', {style: "warning", message: "Ops. Algo aconteceu. Não foi possível gerar o pedido.", floater: true})
          window.spinner.emit("close")
        }
      )
    },
    logOut() {
      this.$store.dispatch('auth/logout')
      this.$router.go()
    },
    compactHeader () {
      window.addEventListener('scroll', () => {
        // console.log(e)
        const scrollTop = window.scrollY || window.pageYOffset
        this.compact = scrollTop > 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>

  .seller-page-container {
    background-color: $color-secondary;
    min-height: 100vh;
    width: 100%;
    // overflow-x: hidden;
    position: relative;
  }
  
  .content-wrapper {
    width: 70%;
    margin: 0 auto;
  }
  
  .seller-page-header :deep(> div) {
    width: 70%;
    margin: 0 auto;
  }

  .page-inner {
    padding: $mg_large $mg $mg;
  }

  .nfFooter {
      display: flex;
      justify-content: space-between;
    }

    .checkoutDetails {
    width: 100%; border-top: 1px solid $color-bg;
    padding-top: $hmg; margin-top: $hmg;
    @extend %transition_4e;

    .detailsSpinner {
      margin: auto;
    }

    > div {
      display: flex; align-content: stretch; align-items: stretch;

      &.checkoutDetailsLists {
        header {
          display: flex;
          align-items: center; align-content: center;
          justify-content: space-between;
          margin-bottom: $hmg;

          > div {
            align-items: center; align-content: center;
            justify-content: flex-end;
            .btn {
              margin-left: $hmg_small
            }
          }
        }

        > div {
          &:first-child {
            width: 100%;
          }

          // &:last-child {
          //   flex: 2
          // }

          ul {
            width: 100%; height: auto;
            padding: 0; margin: 0;

            >li {
              width: 100%; list-style: none;

              >div:not(.splitRules) {
                display: flex; align-content: center; align-items: center;
                justify-content: space-between;
                padding: $hmg_mini 0; border-bottom: 1px solid $color-light;
                margin: 0;

                > span:last-child {
                  text-align: right;
                }
              }
              
              .student {
                display: flex; align-content: center; align-items: center;
                width: 100%; background-color: $color-bg; padding: $hmg_mini;
                // border-bottom-left-radius: 1em; border-bottom-right-radius: 1em;
                margin-bottom: $hmg_mini; font-size: 12px; line-height: 1;
                
                p {padding: 0 0 0 $hmg_mini; margin: 0; font-size: 11px; line-height: 1} 
              }
            }

            &.fixed {
              li {
                white-space: nowrap;
              }
            }
          }

          ol {
                padding: 0 0 0 34px; margin: 0 0 $hmg_small 0;
                border-bottom: 2px solid $color-light;

                li {
                  width: 100%;
                  list-style: decimal; padding: 3px 0;
                  margin: 0; position: relative;

                  > div:not(.deliver) {
                    justify-content: space-between; width: 100%;
                    display: flex; align-content: center; align-items: flex-start;

                    > span {
                      &:first-child {
                        white-space: normal;
                      }
                    }
                  }

                  
                }
              }
        }

        table {
          width: 100%;
          border-collapse: collapse;
          border: 0;
          thead {
            th {
              padding: .4em;
              border-bottom: 2px solid $color-light
            }
          }
          tbody {
            tr {
              @extend %transition_3o;

              td {
                padding: .4em;
                border-bottom: 1px solid $color-light;

                &:first-child{
                  padding-left: $mg_mini;
                }

                a {
                  display: inline-block;
                  margin-left: $mg_mini;

                  &:first-child{margin-left: 0;}
                  &:hover{
                    color: $color-primary
                  }
                }
              }

              &:hover:not(.totais) {
                background-color: $color-bg;
              }

              &.over {
                background-color: $color-alert-light;

                &:hover {
                  background-color: $color-alert-light-hover;
                }
              }
              &.cancelado {
                td {
                  opacity: .4;
                }
              }
            }
          }
          tfoot {
            th {
              padding: $hmg_mini;
              font-size: 13px;
              border-top: 1px solid $color-bg;
              border-bottom: 1px solid $color-bg;
              
              a {
                .icon {
                  transform-origin: center;
                  @extend %transition_4e;
                }
                
                &:hover { 
                  color: $color-primary;
                  .icon{
                    transform: scale(1.1);
                  }
                }
              }
            }
          }
        }

        .tableSpinner {
          width: 100%; height: 300px; 
          display: flex; align-content: center; align-items: center; justify-content: center;
          background-color: $color-bg;
        }

        .deliver {
          // position: absolute; top: 4px; left: -30px;
          // z-index: 100;

          .icon {
            color: $color-bg; font-size: 12px;

            &.active {
              color: $color-success-2
            }
          }

          span {
            line-height: 1; padding: 4px 8px;
            // position: absolute;
            // border-radius: 1em;
            // background-color: $color-success-2;
            // color: $color-secondary;
            right: 0; top: 50%;
            // box-shadow: 1px 2px 4px rgba(16, 122, 73, 0.3);
            opacity: 0; white-space: nowrap;
            @extend %transition_4e;
            // pointer-events: none;
          }

          // &:hover {
          //   span {
          //     transform: translate(105%, -50%); opacity: 1;
          //     pointer-events: all;
          //   }
          // }
        }
      }
    }
  }

  .emptyMessage {
    .icon {
      font-size: 44px;
      margin-bottom: $hmg_mid;
    }
  }

  .cardsub {
    display: flex; align-content: center !important; align-items: center !important;
    margin-bottom: $hmg_small;

    h6 {
      margin: 0; padding: 0;
    }
    .icon {
      margin-right: $hmg_mini
    }
  }
  
  .listStamp {
    display: flex; align-content: center; align-items: center;
    position: absolute; bottom: 0; left: 66px;
    transform: translateY($hmg_mini);
    background-color: $branco;
    border: $border-component;
    border-radius: $border-radius-small;
    padding: $hmg_mini;
    font-size: $font-size-mini;
    line-height: 1;

    p {
      margin: 0; padding: 0;
    }
    .icon {
      margin-right: $hmg_mini
    }
  }

  .icon.error {
    font-size: 16px !important; color: $color-alert !important
  }

  .sep {
    display: block;
    width: 1px; height: 24px;
    background-color: $color-primary;
    transform: translateY(-3px);
    margin: 0 .4em;
  }

  .seller-custom-header-wrapper {
    width: 100%; height: 120px;
    border-bottom: $border-component;
    background-color: $color-secondary;
    position: sticky;
    top: 0;
    z-index: 500;
    @extend %transition_4o;

    &.compact {
      height: 80px;
    }
  }

  .seller-custom-header {
    display: flex; align-items: center;
    height: 100%;
    justify-content: space-between;
    padding: 0 $hmg_mid;
    margin: 0 auto;

    .header-logo {
      display: flex;
      align-items: center;
      width: 20%;
    }

    .header-title {
      flex: 1;
      text-align: center;
      h2 {
        margin: 0;
        padding: 0;
        font-size: 1.5rem;
        font-weight: 600;
        color: $color-text;
      }
    }

    .header-action {
      display: flex;
      justify-content: flex-end;
      width: 20%;
      
      .btn-logout {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: transparent;
        color: $color-text;
        border: $border-component;
        @extend %transition_3o;

        &:hover {
          color: $color-primary;
          border-color: $color-primary !important;
        }

        .icon {
          font-size: 18px;
        }
      }
    }
  }

  footer {
    display: flex; width: 100%;
    border-top: $border-component;
    padding: $hmg_mid;
    position: fixed; z-index: 300;
    bottom: 0; left: 0;
    background-color: $color-secondary;
    align-items: center;
    justify-content: space-between;

    >div {
      display: flex;
      align-items: center;
      gap: $hmg_small
    }
  }

  .form-actions {
    margin-top: 0
  }

  .pageAlert {
    position: sticky; height: 60px;
    width: 100%; top: 80px;
    background-color: $color-bg;
    z-index: 200;
    display: flex; align-items: center;
    justify-content: center;
    text-align: center;
    padding: 0 $hmg_mid;
    gap: $mg_mini;

    p {
      margin: 0; padding: 0;
    }
  }

  .amountTag {
    padding: $hmg_mini $mg_mini;
    border-radius: 2em; background-color: $color-bg;
    margin-left: $hmg_small;
  }
</style>
